import React, { useState, useContext } from 'react';
import { Modal, Spinner, ModalFooter } from 'reactstrap';
import { MdLockOutline } from "react-icons/md";
import { authorize } from '../../shared/authorize';
import { adminBaseURL } from '../../constants/API';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Language } from '../../App';

const PaymentPopupModal = ({ isOpen, data, courseId, toggle }) => {

  // Only for course 606, use hardcoded logic, otherwise use database price
  const actualPrice = data?.id === 606 
    ? (data?.purchases_count < 20 ? 2200 : 2750)
    : (data?.price !== undefined ? data.price : 0);
  const formattedPrice = Number(actualPrice).toFixed(2);
   const { lang } = useContext(Language);

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Don't show popup for free courses
  if (actualPrice === 0) {
    return null;
  }

  const handlePurchase = async () => {
    setIsLoading(true);

    if (actualPrice > 0) {
      navigate("/paypal-payment", { state: { data } });
      setIsLoading(false);
      return;
    }

    try {
      const res = await axios.post(
        `${adminBaseURL}user/course/purchase`,
        { course_id: courseId },
        authorize()
      );

      if (res.data.status) {
        toggle();
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }

    setIsLoading(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      
      contentClassName="border-0 shadow rounded-3 p-0"
      className="modal-dialog-centered"
      size="md"
    >

      {/* HEADER */}
      <div 
        className="text-center m-2 text-white p-4 rounded-top" 
        style={{ backgroundColor: '#1e2828' }}
      >
        <h2 className="fw-bold mb-0" style={{ fontSize: "25px" }}>
          {actualPrice === 0 ? lang.free : `${lang.purchase_btn1} €${formattedPrice}`}
        </h2>

        <p className="mt-2 mb-0">
          <MdLockOutline size={20} style={{ marginBottom: "5px" }} />{" "}
          {lang.purchase}
        </p>
      </div>

      {/* BODY */}
      <div className="p-4 pt-3">

        <h4 className="outfit-bold mb-2">
      {lang.purchase_title}
        </h4>

        <p className="mb-3 text-black" style={{ fontSize: "18px" }}>
         {lang.purchase_desc}
        </p>

        {/* FOOTER */}
    <ModalFooter
  className=" d-flex gap-2"
  style={{
    marginLeft: "-1.5rem",
    marginRight: "-1.5rem",
   marginBottom:"-25px"
  }}
>

  <div style={{ flex: 1 }}>
    <button
      onClick={toggle}
      style={{
        width: "100%",
        backgroundColor: "#031316",
        color: "white",
        border: "none",
        padding: "16px",
        borderRadius: "8px",
        fontWeight: "500"
      }}
    >
      {lang.cancell}
    </button>
  </div>

  <div style={{ flex: 1 }}>
    <button
      onClick={handlePurchase}
      disabled={isLoading}
      style={{
        width: "100%",
        background: "linear-gradient(180deg, #33CDE5 0%, #009AB2 100%)",
        color: "white",
        border: "1px solid #0793ab",
        padding: "16px",
        borderRadius: "8px",
        fontWeight: "600"
      }}
    >
      {isLoading ? (
  <Spinner size="sm" color="light" />
) : actualPrice === 0 ? (
  lang.purchase_btn
) : (
  `${lang.purchase_btn1} €${formattedPrice}`
)}
    </button>
  </div>

</ModalFooter>

      </div>

    </Modal>
  );
};

export default PaymentPopupModal;
